import { useTranslation } from "react-i18next";
import CustomButton from "../ui/CustomButton/CustomButton";
import comingSoonIcon from ".././../assets/images/comingSoon.png";
import "./ComingSoon.scss";

interface IProps {
  isSubscribed?: boolean;
  onNotifyMe: () => void;
}

export const ComingSoon = ({ isSubscribed, onNotifyMe }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className="coming-soon">
      <img width={244} height={244} src={comingSoonIcon} alt="coming soon block" />

      <h4 className="coming-soon__title">{t("ComingSoon")}!</h4>
      <p className="coming-soon__desc">{t("ComingSoonDesc")}</p>
      <p className="coming-soon__desc2">{t("ComingSoonDesc2")}</p>

      {isSubscribed ? (
        <div className="coming-soon__subscribed">
          <div className="coming-soon__subscribed__btn">
            <p className="coming-soon__subscribed__btn__text">{t("ComingSoonDescSubscribed")}</p>
          </div>

          <p className="coming-soon__subscribed__text">{t("ComingSoonDescSubscribed2")}</p>
        </div>
      ) : (
        <CustomButton
          style={{ width: 200 }}
          text={t("NotifyMe")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={onNotifyMe}
        />
      )}
    </div>
  );
};
